<template>
  <FilterLayout title="Analytics" :options="options" :selectedText="selectedText" auto @clear="$emit('input', [])">
    <div class="hvh-flex column">
      <div class="hvh-flex space-between toggle-all no-wrap">
        <div class="clickable" @click="selectAll">SELECT ALL</div>
        <div class="clickable ml-5" @click="$emit('input', [])">DESELECT ALL</div>
      </div>
      <v-text-field class="my-3" v-model="searchText" label="Search Analytics" prepend-inner-icon="mdi-magnify" :hideDetails="true" outline />
      <div class="options-box">
        <div class="hvh-flex aling-center mb-3 pr-5" v-for="option in filteredOptions" :key="option.item">
          <CheckBox :value="(value || []).includes(option.item)" @input="emitData(option.item)" />
          <span class="clickable no-wrap ml-2" @click="emitData(option.item)">{{ option.item }} ({{ option.count }})</span>
        </div>
      </div>
    </div>
  </FilterLayout>
</template>

<script>
import FilterLayout from './FilterLayout.vue';
import cloneDeep from 'clone-deep';
import axios from '../../../../axios';
import { errorDebug, hashCode } from '../../../../libraries/common';
import CheckBox from '../../../common/form/checkbox/CheckBox.vue';
export default {
  components: { FilterLayout, CheckBox },
  props: ['value', 'filters'],
  data() {
    return {
      options: null,
      searchText: null,
      showOptions: true,
    };
  },
  computed: {
    filteredOptions() {
      return (this.options || [])
        .filter(f => !this.searchText || f.item.toLowerCase().includes(this.searchText.toLowerCase()))
    },
    selectedText() {
      if (!(this.value || []).any()) return '';
      return `${this.value.first()} ${this.value.length > 1 ? `+${this.value.length - 1}` : ''}`.trim();
    },
    filterHashCode() {
      return hashCode(this.filters);
    },
  },
  methods: {
    emitData(item) {
      this.$emit('input', (this.value || []).toggle(item).sortBy(f => this.options.findIndex(g => g.item === f)));
    },
    selectAll() {
      this.$emit('input', cloneDeep(this.options.map(f => f.item)));
    },
    getFilterOptions() {
      axios.post('/Analytics/Cohorts/AnalyticsFilterOptions', this.filters)
        .then(response => this.options = response.data)
        .catch(errorDebug)
    },
   
  },
  watch: {
    filterHashCode() {
      this.getFilterOptions();
    },
  },
  mounted() {
    this.getFilterOptions();
  },
}
</script>

<style lang="scss" scoped>
.toggle-all {
  color: #002f6c;
  font-size: 12px;
  font-weight: 500;
}

.options-box {
  overflow: auto;
  max-height: 200px;
}
</style>